export const GUEST_SESSION_KEY = 'spectrai-guest-mode'

export function readGuestSession(): boolean {
  try {
    return sessionStorage.getItem(GUEST_SESSION_KEY) === '1'
  } catch {
    return false
  }
}

export function writeGuestSession(active: boolean): void {
  try {
    if (active) {
      sessionStorage.setItem(GUEST_SESSION_KEY, '1')
    } else {
      sessionStorage.removeItem(GUEST_SESSION_KEY)
    }
  } catch {
    /* ignore */
  }
}
